import { createParser } from "nuqs";

export const TIME_RANGES = [
    { label: "Last Day", days: 1, value: "last-day" },
    { label: "Last Week", days: 7, value: "last-week" },
    { label: "Last 14 Days", days: 14, value: "last-14-days" },
    { label: "Last Month", days: 30, value: "last-month" },
    { label: "Last 6 Months", days: 180, value: "last-6-months" },
    { label: "Last Year", days: 365, value: "last-year" },
] as const;

export type TimeRange = {
    label: string;
    days: number;
    value: string;
};

export const parseAsTimeRange = createParser({
    parse(queryValue) {
        const range = TIME_RANGES.find((range) => range.value === queryValue);
        if (!range) {
            throw new Error(`Invalid time range: ${queryValue}`);
        }
        return range;
    },
    serialize(value) {
        return value.value;
    },
});

const VIEWS = ["activeUsers", "environments", "totalTime"] as const;
export type View = (typeof VIEWS)[number];

export const parseAsView = createParser<View>({
    parse(queryValue) {
        if (!queryValue || !VIEWS.includes(queryValue as View)) {
            throw new Error(`Invalid view: ${queryValue}`);
        }
        return queryValue as View;
    },
    serialize(value) {
        return value;
    },
});
